/**
 * 地址相关组件
 * @returns
 */

import { getRequest, postRequest } from '@/utils/fetch';

// 省市区 - 选择上门取件、收货地址使用
export const getDictionaries = () => {
    return getRequest('/address/dictionaries');
};

// 获取泰国地址信息
export const getTHAddress = () => {
    return getRequest(
        'https://gss-client-gcs.popmart.com/data/thAddressData.json',
        {},
        {
            withCredentials: false,
            interceptor: true,
        },
    );
};

// 获取国际化通用国家地区信息
export const getCommonAddress = () => {
    return getRequest(
        'https://gss-client-gcs.popmart.com/data/commonRegion.json',
        {},
        {
            withCredentials: false,
            interceptor: true,
        },
    );
};

// 获取原订单收货人地址信息
export const getAddrByOrder = () => {
    return getRequest('/address/dictionaries');
};

// 根据地址信息获取物流预约时间信息
export const orderPreCheck = (params: any) => {
    return postRequest('/css/express/order/precheck', params);
};

// 编辑收件信息
export const updateNewProductSendOutInfo = (params: any) => {
    return postRequest('/css/aftersale/updateNewProductSendOutInfo', params);
};
// 编辑寄件信息
export const updateExpressInfo = (params: any) => {
    return postRequest('/css/aftersale/express/submit', params);
};
// 获取物流公司枚举
export const getExpress = () => {
    return getRequest('/css/common/express/enum');
};

// 预约快递预下单
export const expressPreCheck = (params: any) => {
    return postRequest('/css/express/accord/precheck', params);
};

// 预约快递预下单
export const expressCreateOrder = (params: any) => {
    return postRequest('/css/express/accord/create', params);
};

// 查询快递预约列表
export const getExpressList = (params: any) => {
    return postRequest('/css/express/record/list', params);
};

// 查询快递详情
export const getExpressDetail = (params: any) => {
    return getRequest('/css/express/record/detail', params);
};

// 查询快递详情
export const cancelExpress = (params: any) => {
    return getRequest('/css/express/accord/cancel', params);
};
